/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-10-30 16:34:28
 * @LastEditors: bbq
 * @LastEditTime: 2020-12-07 10:35:40
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '../Tooltip';
import { getMultiLang } from '@platform/api';

require('./index.less');

/**
 * @namespace ToggleViewBtn
 */

/**
 * ToggleViewBtn组件的参数描述
 * @memberof ToggleViewBtn
 * @component ToggleViewBtn
 * @property {string} [expand = false] - 按钮的状态，expand 是单表状态
 * @property {array} [tooltips=['单表显示', '主子表显示']]  - 控制expand和非expand的状态, ['展开时显示提示', '非展开时显示提示']
 * @property {string} className - 自定义className
 * @property {function(expand): void} onClick - 点击按钮事件
 */

export default class ToggleViewBtn extends Component {
    constructor(props) {
        super(props);
        this.state = { expand: props.expand || false, langJson: {} };
    }

    UNSAFE_componentWillMount() {
        let callback = langJson => {
            this.setState({ langJson });
        };
        // moduleId为所需加载langJson文件夹名称前缀
        getMultiLang({ moduleId: 'common', callback });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { expand } = nextProps;
        if (typeof expand !== "undefined" && expand !== null) {
            this.setState({ expand });
        }
    }

    render() {
        let { expand, langJson } = this.state;
        let { onClick, className = '', tooltips = [langJson['common-0005'], langJson['common-0006']], ...others } = this.props;
        let overlay = (
            <div className="button-help-tooltip">
                {(expand ? tooltips[0] : tooltips[1]) || ""}
            </div>
        );
        return (
            <Tooltip
                placement="topRight"
                overlay={overlay}
                delayHide={1}
                delayShow={500}
            >
                <span
                    className={
                        classnames(
                            `${className} toggle-view-btn iconfont icon`,
                            {
                                'nest icon-xingzhuang': !expand,
                                'expand icon-Group': expand,
                            },
                        )
                    }
                    onClick={() => {
                        if (onClick && typeof onClick === 'function') {
                            onClick(!this.state.expand);
                        }
                        this.setState({ expand: !this.state.expand });
                    }}
                    {...others}
                />
            </Tooltip>
        );
    }

}
